import * as Sentry from '@sentry/vue'

export const ADD_TOKEN_TRANSACTION = 'Added new auth token'
export const CLEAR_TOKEN_TRANSACTION = 'The auth token has cleared'
export const NO_TOKEN_TRANSACTION = 'There is no token in localStorage'
export const SETTING_TOKEN_TRANSACTION = 'The new token has been set in localStorage'

export function sendSentryData ({ transactionName, description, data }) {
  const transaction = Sentry.startTransaction({ name: transactionName })
  Sentry.getCurrentHub().configureScope(scope => scope.setSpan(transaction))
  const span = transaction.startChild({
    data,
    op: 'task',
    description
  })
  span.finish()
  transaction.finish()
}

export function getShopData () {
  try {
    const data = localStorage.getItem('TA')
    if (!data) {
      throw new Error()
    }
    const parsedData = JSON.parse(data)
    return {
      shopId: parsedData ? String(parsedData.shop.id) : '',
      shopName: parsedData ? String(parsedData.shop.name) : '',
      tickPointId: parsedData ? String(parsedData.tickPoint.id) : '',
      currentToken: localStorage.getItem('K2')
    }
  } catch {
    return {
      shopId: '',
      shopName: '',
      tickPointId: '',
      currentToken: ''
    }
  }
}

export function sendInfoException (msg, newToken) {
  const shopData = getShopData()
  setTimeout(() => {
    Sentry.withScope(function (scope) {
      scope.setLevel('info')
      scope.setContext('token', {
        newToken,
        ...shopData
      })
      Sentry.captureException(msg)
    })
  }, 2000)
}
